<template>
  <div class="home-page">
    <home-message />
  </div>
</template>

<script>
import homeMessage from './homeMessage'
export default {
  name: 'Index',
  components: {
    homeMessage
  },
  data() {
    return {}
  },
  computed: {},
  methods: {}
}
</script>

<style lang="scss" scoped>
.home-top {
  min-height: 3.6rem;
  background: url("../../assets/image/home-bg.png") no-repeat;
  background-size: 100% 100%;
  text-align: center;
  color: #fff;
  padding: 0.48rem 0 0.6rem;
  .home-top_title {
    font-size: 0.32rem;
    font-weight: bold;
    margin-bottom:0.9rem;
  }
  .line {
    height: 0.82rem;
    width: 1px;
    background: rgba(255,255,255,0.2);
  }
}
</style>
